<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4UoY2q/tc-custom/9781623808983.jpg?1726686748800" alt="This image is the cover for the book Winter Ball, Winter Ball"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Winter Ball, Winter Ball
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>a Winter Ball novel</i></b></p><p>Through a miserable adolescence and a lonely adulthood, Skipper Keith has dreamed of nothing but family. The closest he gets is the rec league soccer team he coaches after work—and his star player and best friend, Richie Scoggins.</p><p>One brisk night in late October, a postpractice convo in Richie’s car turns into a sexual encounter neither of them expected—nor want to forget. Soon Skip and Richie are living for the weekends and their winter league soccer games—and the games they enjoy off the field. Through broken noses, holiday decorating, and the killer flu, they learn more about each other than they ever dreamed possible. Every new discovery takes them further beyond the boundaries of the soccer field and into the infinite possibilities of the best relationship of Skipper’s life.</p><p>Skipper can’t dream of a better family than Richie—but Richie’s got real family entanglements he can’t shake off. Skipper needs to convince Richie to stay with him beyond winter ball so the relationship they started on the field might become their happy future in real life!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Lane
      </h2>
      
      <p class="authorDescription body article"><P>Award winning author Amy Lane lives in a crumbling crapmansion with a couple of teenagers, a passel of furbabies, and a bemused spouse. She has too damned much yarn, a penchant for action-adventure movies, and a need to know that somewhere in all the pain is a story of Wuv, Twu Wuv, which she continues to believe in to this day! She writes contemporary romance, paranormal romance, urban fantasy, and romantic suspense, teaches the occasional writing class, and likes to pretend her very simple life is as exciting as the lives of the people who live in her head. She&rsquo;ll also tell you that sacrifices, large and small, are worth the urge to write.</P><P>Website: www.greenshill.com</P><P>Blog: www.writerslane.blogspot.com</P><P>Email: amylane@greenshill.com</P><P>Facebook: www.facebook.com/amy.lane.167</P><P>Twitter: @amymaclane</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bdfe893a